export default "__VITE_ASSET__8r8bj9g4__"